if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.changeHandler = this.handleChange.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.addEventListener('change', this.changeHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.removeEventListener('change', this.changeHandler);
    }

    /**
     * Handles cart form submit.
     * 28 Sep 2026 (Omnitub approved, mobile audit F5): the tick stays (sign-before-pay ruling), but an
     * unticked checkout no longer raises a blocking system alert(). The message now sits inline under
     * the tick, and the page scrolls the tick into view and focuses it. The sticky "Checkout" bar on
     * phones clicks the real Checkout button, so it lands here too.
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (this.cartTermsCheckbox.checked) return;
      evt.preventDefault();
      // A tick the shopper cannot see (hidden by a merged sign-off panel) must never block silently:
      // only in that state does the old system message remain as the last resort.
      if (!this.getClientRects().length) {
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
        return;
      }
      this.showError();
    }

    handleChange() {
      if (this.cartTermsCheckbox.checked) this.clearError();
    }

    showError() {
      let msg = this.querySelector('[data-cart-terms-error]');
      if (!msg) {
        msg = document.createElement('p');
        msg.id = 'cart-terms-error-' + (this.form.id || 'cart');
        msg.setAttribute('data-cart-terms-error', '');
        msg.setAttribute('role', 'alert');
        msg.style.cssText = 'margin:10px 0 0;padding:10px 14px;border-left:3px solid #9A2A2E;background:#F7ECEC;'
          + 'color:#7A1F23;font-size:1.7rem;line-height:1.45;font-weight:500;border-radius:6px;text-align:left;';
        this.appendChild(msg);
      }
      msg.textContent = (window.theme && theme.strings && theme.strings.cartTermsConfirmation)
        || 'Please tick the box to accept the terms and refund policy \u2014 then tap Checkout again.';
      this.cartTermsCheckbox.setAttribute('aria-invalid', 'true');
      this.cartTermsCheckbox.setAttribute('aria-describedby', msg.id);
      try {
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (e) {
        this.scrollIntoView();
      }
      const box = this.cartTermsCheckbox;
      setTimeout(() => {
        try { box.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
      }, 400);
    }

    clearError() {
      const msg = this.querySelector('[data-cart-terms-error]');
      if (msg) msg.remove();
      this.cartTermsCheckbox.removeAttribute('aria-invalid');
      this.cartTermsCheckbox.removeAttribute('aria-describedby');
    }
  }
  customElements.define('cart-terms', CartTerms);
}
